import apiService from './api'

/**
 * Transaction History API Service
 * Обрабатывает все API запросы связанные с историей транзакций
 */

export const transactionApi = {
  /**
   * Получение всей истории транзакций пользователя
   * Returns: { history: [...], me: {...}, alert?: string, error?: string }
   */
  async getTransactionHistory() {
    try {
      const response = await apiService.get('/api/history/')
      
      // Проверяем наличие истории в ответе
      if (!response.history) {
        console.warn('⚠️ История транзакций не найдена в ответе API')
        return { history: [], me: response.me }
      }
      
      // Сортируем историю от новых к старым (по возрастанию sec_ago - меньшее значение = новее)
      const sortedHistory = response.history.sort((a, b) => a.sec_ago - b.sec_ago)
      
      return {
        ...response,
        history: sortedHistory
      }
    } catch (error) {
      console.error('❌ Ошибка получения истории транзакций:', error)
      throw error
    }
  },

  /**
   * Получение типа транзакции по номеру
   * @param {string|number} typeNumber - Номер типа транзакции
   * @returns {string} - Ключ для локализации типа транзакции
   */
  getTransactionTypeKey(typeNumber) {
    const typeMap = {
      '1': '1', // Бонус за регистрацию
      '2': '2', // Пополнение баланса
      '3': '3', // Открытие кейса
      '4': '4', // Продажа предмета
      '5': '5', // Зачисление администратором
      '6': '6', // Списание администратором
      '7': '7', // За регистрацию реферала
      '8': '8', // Доход от реферала
      '9': '9', // Ежедневный бонус
      '10': '10', // За привязку Steam
      '11': '11', // За привязку FaceIt
      '12': '12', // Штраф за непринятый или отклоненный трейд
      '13': '13', // Награда за бота в ФИО ТГ
      '14': '14', // Награда за аватар в профиле ТГ
      '15': '15', // Награда за подписку на канал ТГ
      '16': '16', // Награда за подписку на чат ТГ
      '17': '17', // Награда за ФИО в нике Steam
      '18': '18', // Награда за аватар в Steam
      '19': '19', // Бонус за реферальную ссылку в Telegram Bio
      '20': '20', // Бонус за первое пополнение
      '21': '21', // Покупка в магазине
      '22': '22', // Создание кейсбатла
      '23': '23', // Возврат за кейсбатл
      '24': '24', // Зачисление СБП
      '25': '25', // Зачисление crypto
      '26': '26', // Зачисление UZS
      '27': '27', // Ставка в королевскую битву
      '28': '28', // Выигрыш в королевской битве
      '29': '29', // Возврат кристаллов за королевскую битву
      '30': '30', // Пополнение картой РФ
      '31': '31', // Пополнение скинами Steam
      '32': '32'  // Пополнение KZT
    }
    
    return typeMap[typeNumber.toString()] || typeNumber.toString()
  },

  /**
   * Форматирование времени "назад" на основе секунд
   * @param {number} secAgo - Количество секунд назад
   * @param {function} t - Функция перевода i18next
   * @returns {string} - Отформатированное время
   */
  formatTimeAgo(secAgo, t) {
    const seconds = parseInt(secAgo)
    
    // Меньше минуты
    if (seconds < 300) {
      return t('transactions.timeAgo.justNow')
    }
    
    // Минуты
    if (seconds < 3600) {
      const minutes = Math.floor(seconds / 60)
      if (minutes === 1) {
        return t('transactions.timeAgo.minuteAgo')
      }
      return t('transactions.timeAgo.minutesAgo', { count: minutes })
    }
    
    // Часы
    if (seconds < 86400) {
      const hours = Math.floor(seconds / 3600)
      if (hours === 1) {
        return t('transactions.timeAgo.hourAgo')
      }
      return t('transactions.timeAgo.hoursAgo', { count: hours })
    }
    
    // Дни
    const days = Math.floor(seconds / 86400)
    if (days === 1) {
      return t('transactions.timeAgo.dayAgo')
    }
    return t('transactions.timeAgo.daysAgo', { count: days })
  }
}

export default transactionApi
